export function isCurrentPlayerDayResponse({
  requestId,
  latestRequestId,
  requestedDate,
  selectedDate,
  responseDate,
}) {
  return requestId === latestRequestId
    && requestedDate === selectedDate
    && responseDate === requestedDate;
}
